import React, { useState, useCallback, useEffect } from "react";
import { database } from "./firebase";
import { ref, query, onValue, orderByKey } from "firebase/database";
// import Barcode from "react-barcode";
import { FaWhatsapp, FaInstagram, FaMicrophone } from 'react-icons/fa';

// Adicione este novo componente SkeletonCard
const SkeletonCard = () => (
  <div
    style={{
      backgroundColor: "#f9f9f9",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      padding: "15px",
      textAlign: "center",
      animation: "pulse 1.5s infinite ease-in-out",
    }}
  >
    <div 
      style={{ 
        height: "30px",
        backgroundColor: "#e0e0e0",
        borderRadius: "4px",
        marginBottom: "14px",
      }} 
    />
    <div 
      style={{ 
        height: "24px",
        backgroundColor: "#e0e0e0",
        borderRadius: "4px",
        marginBottom: "10px",
        width: "80%",
        margin: "0 auto 10px",
      }} 
    />
    <div 
      style={{ 
        height: "18px",
        backgroundColor: "#e0e0e0",
        borderRadius: "4px",
        width: "60%",
        margin: "0 auto 10px",
      }} 
    />
    <div 
      style={{ 
        height: "16px",
        backgroundColor: "#e0e0e0",
        borderRadius: "4px",
        width: "40%",
        margin: "0 auto",
      }} 
    />
  </div>
);

// Adicione este estilo no seu CSS
const skeletonStyle = `
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;

const App = () => {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ musica: "", artista: "" });
  const [appliedFilters, setAppliedFilters] = useState({ musica: "", artista: "" });
  const [hasSearched, setHasSearched] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [currentField, setCurrentField] = useState(null);

  useEffect(() => {
    document.body.style.backgroundColor = "#f0f0f0"; // Define o fundo cinza para a página toda
    return () => {
      document.body.style.backgroundColor = ""; // Restaura o fundo quando o componente for desmontado
    };
  }, []);

  const safeDecodeURIComponent = (str) => {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      console.error("Erro ao decodificar:", str, e);
      return str;
    }
  };

  const removeAccents = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const loadSongs = useCallback(() => {
    setLoading(true);
    const songsRef = ref(database);
    const songsQuery = query(songsRef, orderByKey());

    const unsubscribe = onValue(
      songsQuery,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const songsArray = Object.entries(data).map(([key, value]) => ({
            id: key,
            Musica: safeDecodeURIComponent(value.Musica),
            Artista: safeDecodeURIComponent(value.Artista),
            inicio: safeDecodeURIComponent(value.inicio),
          }));
          setSongs(songsArray);
        } else {
          setSongs([]);
        }
        setLoading(false);
      },
      (error) => {
        console.error("Erro ao carregar os dados:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const handleSearchClick = () => {
    // Remove espaços extras no final dos filtros antes de aplicar
    const trimmedFilters = {
      musica: filters.musica.trimEnd(),
      artista: filters.artista.trimEnd()
    };

    if (!trimmedFilters.musica && !trimmedFilters.artista) return;
    
    setAppliedFilters(trimmedFilters);
    setHasSearched(true);
    loadSongs();
  };

  const handleClearClick = () => {
    setFilters({ musica: "", artista: "" });
    setAppliedFilters({ musica: "", artista: "" });
    setHasSearched(false);
    setSongs([]);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleVoiceSearch = async (fieldName) => {
    try {
      // Verifica se está em um dispositivo iOS
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      
      // Se for iOS ou Safari, mostra mensagem específica
      if (isIOS || isSafari) {
        alert('O reconhecimento de voz não está disponível no iPhone. Por favor, use um dispositivo Android com Chrome ou use o teclado para digitar sua busca.');
        return;
      }

      // Se já estiver ouvindo, para a gravação atual
      if (isListening) {
        setIsListening(false);
        setCurrentField(null);
        return;
      }

      // Verifica se o navegador suporta a API
      if (!('webkitSpeechRecognition' in window)) {
        alert('Seu navegador não suporta reconhecimento de voz. Por favor, use o Chrome em um dispositivo Android.');
        return;
      }

      const SpeechRecognition = window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      
      recognition.continuous = false;
      recognition.lang = 'pt-BR';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      
      recognition.onstart = () => {
        setIsListening(true);
        setCurrentField(fieldName);
      };
      
      recognition.onend = () => {
        setIsListening(false);
        setCurrentField(null);
      };
      
      recognition.onresult = (event) => {
        if (event.results && event.results[0]) {
          const transcript = event.results[0][0].transcript;
          setFilters(prev => ({ ...prev, [fieldName]: transcript }));
        }
      };

      recognition.onerror = (event) => {
        console.error('Erro no reconhecimento de voz:', event.error);
        setIsListening(false);
        setCurrentField(null);
      };

      await recognition.start();

    } catch (error) {
      console.error('Erro ao iniciar reconhecimento de voz:', error);
      setIsListening(false);
      setCurrentField(null);
    }
  };

  const filteredSongsList = songs.filter(song => {
    const matchMusica = appliedFilters.musica 
      ? removeAccents(song.Musica).includes(removeAccents(appliedFilters.musica))
      : true;
      
    const matchArtista = appliedFilters.artista 
      ? removeAccents(song.Artista).includes(removeAccents(appliedFilters.artista))
      : true;

    return matchMusica && matchArtista;
  });

  return (
    <div style={{ 
      fontFamily: "Arial, sans-serif", 
      paddingTop: "60px", 
      paddingLeft: "5px",  // Reduzido de 10px para 5px
      paddingRight: "5px", // Reduzido de 10px para 5px
      maxWidth: "100%",    // Garante que não vai estourar a largura
      boxSizing: "border-box" // Inclui padding no cálculo da largura
    }}>
      <style>{skeletonStyle}</style>
      
      <header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: "#000",
          color: "#fff",
          padding: "5px 0",
          zIndex: 1000,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 15px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <FaWhatsapp size={16} />
          <a 
            href="https://wa.me/5582996806110"
            style={{ 
              fontSize: "14px",
              color: "#FFF",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: "5px"
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            82 99680-6110
          </a>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <img 
            src="logo.jpg" 
            alt="Logo do projeto" 
            style={{ width: "90px", height: "auto",position:"relative", top: "5px" }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <FaInstagram size={16} />
          <a 
            href="https://www.instagram.com/cantaai_karaoke/" 
            style={{ 
              fontSize: "14px", 
              color: "#FFF", 
              textDecoration: "none" 
            }}
          >
          cantaai_karaoke
          </a>
        </div>
      </header>

      <h1 style={{ textAlign: "center", fontSize: "20px", marginTop: "50px" }}>Lista de Músicas do Karaoke</h1>

      <div style={{ 
        marginBottom: "20px", 
        display: "flex", 
        flexDirection: "column", 
        gap: "10px",
        width: "100%",    // Garante largura total
        boxSizing: "border-box" // Inclui padding no cálculo da largura
      }}>
        <div style={{ position: "relative", width: "100%" }}>
          <input
            type="text"
            name="musica"
            placeholder="Filtrar por música"
            value={filters.musica}
            onChange={handleFilterChange}
            style={{ 
              width: "100%",
              padding: "8px 40px 8px 8px",
              fontSize: "20px",
              height: "50px",
              borderRadius: "5px", 
              marginBottom: "20px",
              boxSizing: "border-box"
            }}
          />
          <button
            onClick={() => handleVoiceSearch('musica')}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "30px",
              width: "30px",
              marginTop: "-10px",
            }}
          >
            <FaMicrophone 
              size={24}
              color={isListening && currentField === 'musica' ? "#ff0000" : "#E67E22"}
            />
          </button>
        </div>

        <div style={{ position: "relative", width: "100%" }}>
          <input
            type="text"
            name="artista"
            placeholder="Filtrar por artista"
            value={filters.artista}
            onChange={handleFilterChange}
            style={{ 
              width: "100%",
              padding: "8px 40px 8px 8px",
              fontSize: "20px",
              height: "50px",
              borderRadius: "5px",
              marginBottom: "20px",
              boxSizing: "border-box"
            }}
          />
          <button
            onClick={() => handleVoiceSearch('artista')}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "30px",
              width: "30px",
              marginTop: "-10px",
            }}
          >
            <FaMicrophone 
              size={24}
              color={isListening && currentField === 'artista' ? "#ff0000" : "#E67E22"}
            />
          </button>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={handleSearchClick}
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "16px",
              backgroundColor: "#000",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Buscar
          </button>
          <button
            onClick={handleClearClick}
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "16px",
              backgroundColor: "#888",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Limpar
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          gap: "20px",
          marginTop: "20px"
        }}>
          {[...Array(8)].map((_, index) => (
            <SkeletonCard key={index} />
          ))}
        </div>
      ) : (
        <>
          {hasSearched && (
            <p style={{ textAlign: "center", fontSize: "16px", marginBottom: "10px", fontWeight: "bold" }}>
              {filteredSongsList.length > 0 
                ? `Foram encontradas ${filteredSongsList.length} música(s)`
                : "Nenhuma música corresponde à pesquisa"}
            </p>
          )}

          {filteredSongsList.length > 0 && (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
              gap: "20px",
              marginTop: "20px"
            }}>
              {filteredSongsList.map(song => (
                <div
                  key={song.id}
                  style={{
                    backgroundColor: "#f9f9f9",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    padding: "15px",
                    textAlign: "center",
                  }}
                >
                {/*<Barcode value={song.id} format="CODE128" width={1.5} height={50} displayValue={false} />*/}
                  <h3 style={{ color: "#df5b5b", fontSize: "22px", marginBottom: "14px" }}>{song.id}</h3>
                  <h3 style={{ color: "#333", fontSize: "18px", marginBottom: "10px" }}>{song.Musica}</h3>
                  <p style={{ color: "#666", fontSize: "14px" }}>{song.Artista}</p>
                  <p style={{ color: "#888", fontSize: "12px" }}>Início: {song.inicio}</p>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default App;

